import React, { useCallback } from 'react';

import { CasinoGame } from '../../hooks/use-casino-games';
import { useCarouselCardSize } from '../../hooks/use-desktop-carousel';
import { CasinoLayoutProps } from '../../utils/utils';
import { CasinoGameCardBase } from '../CasinoGameCardBase';
import { DesktopCarousel } from './DesktopCarousel';

const VISIBLE_CARDS = 6;

const keyExtractor = (item: CasinoGame) => item.id;

export const SingleRowLayout = ({ data, layoutHeaderProps }: CasinoLayoutProps) => {
    const cardSize = useCarouselCardSize(VISIBLE_CARDS);

    const renderItem = useCallback(
        ({ item }: { item: CasinoGame }) => (
            <CasinoGameCardBase game={item} cardHeight={cardSize} cardWidth={cardSize} imageHeight={cardSize} />
        ),
        [cardSize]
    );

    return (
        <DesktopCarousel
            data={data}
            itemWidth={cardSize}
            visibleCount={VISIBLE_CARDS}
            keyExtractor={keyExtractor}
            renderItem={renderItem}
            layoutHeaderProps={layoutHeaderProps}
            viewAllHeight={cardSize}
        />
    );
};
